import React, { useState, useEffect } from 'react';
import { Notification, Card, Title, Table, Button, Box, Modal, Progress, Column, Select } from "rbx";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import PdvService from '../../../services/pdv';
import PaginationCustom from '../../components/PaginationCustom';
import { payMethods, states, types } from '../../../commons/constants';
import { monetaryMask } from '../../../commons/masks';

const styleHr = { backgroundColor: 'transparent', borderColor: 'rgb(221, 221, 221)', borderStyle: 'dashed', borderWidth: '1px 0px 0px', margin: '3px' };

const PdvTransactionsHistoryList = (props) => {
  const { goToMenu } = props;
  const [limit, setLimit] = useState(50);
  const [histories, setHistories] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);
  const [activeModal, setActiveModal] = useState(false);
  const [activeProgress, setActiveProgress] = useState(true);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [status, setStatus] = useState('');

  useEffect(() =>{
    fetchTransactionsHistory();
  },[limit])

  const fetchTransactionsHistory = async () => {
    const pdv = await JSON.parse(sessionStorage.getItem('pdv'));
    try {
      const response = await PdvService.transactionsHistory({ cpf: pdv.cpf_cnpj, limit: limit });
      setHistories(response.data.history);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setActiveProgress(false);
  }

  const openModal = (index) => {
    setActiveModal(true);
    setSelectedHistory(index);
  }

  const close = () => setActiveModal(false);

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  const renderTransactionsHistory = () => {
    if (pageOfItems.length === 0)
      return (
        <Table.Row key={0}>
          <Table.Cell colspan="9">
            { (activeProgress) ? <Progress size='small' color='custom-purple' /> : 'Não há histórico de transações.' }
          </Table.Cell>
        </Table.Row>
      )
    else
      return (
        pageOfItems.map((history, index) => (
          <Table.Row key={history._id}>
            <Table.Cell>{moment(history.date).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>{history.quantity}</Table.Cell>
            <Table.Cell>{monetaryMask(history.total_cost/100)}</Table.Cell>
            <Table.Cell>{states[history.state]}</Table.Cell>
            <Table.Cell>
              <Button key={history._id} size="small" color="custom-purple" outlined onClick={() => openModal(index)} title="Detalhe">
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))
      )
  }

  const renderModal = () => {
    if (selectedHistory !== null) {
      const history = pageOfItems[selectedHistory];
      return (
        <Box>
          <Title size={5} className="mb-4">Detalhe da Transação</Title>
          <hr style={ styleHr }/>
          <small><strong>Data transação</strong></small><br />
          {moment(history.date).format('DD/MM/YYYY HH:mm:ss')}
          <hr style={ styleHr }/>
          <small><strong>Quantidade</strong></small><br />
          {history.quantity}
          <hr style={ styleHr }/>
          <small><strong>Custo Total</strong></small><br />
          {monetaryMask(history.total_cost/100)}
          <hr style={ styleHr }/>
          <small><strong>Parceiro?</strong></small><br />
          {history.isPartner ? 'Sim' : 'Não' }
          <hr style={ styleHr }/>
          <small><strong>Forma Pagamento</strong></small><br />
          {payMethods[history.payment_method]}
          <hr style={ styleHr }/>
          <small><strong>Tipo transação</strong></small><br />
          {types[history.type]}
          <hr style={ styleHr }/>
          <small><strong>Situação</strong></small><br />
          {states[history.state]}
        </Box>
      )
    }
  }

  return (
    <>
      <Card>
        <Card.Header>
          <Card.Header.Title>Histórico de Transações</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Column.Group>
            <Column style={{paddingBottom:'0.1rem'}} >
              Exibir até 
                <Select 
                  name="limit"
                  value={limit} 
                  onChange={ e => setLimit(e.target.value) }
                  style={{margin:'0 .5rem'}}
                >
                  {
                    [{value: 50, description: '50'}, {value: 100, description: '100'}, {value: 200, description: '200'}, {value: 500, description: '500'}, {value: 1000, description: '1000'}].map(
                      (item, index) => (<Select.Option key={index} value={item.value}>{item.description}</Select.Option>)
                    )
                  }
                </Select>
              registros
            </Column>
          </Column.Group>
          <hr style={ styleHr }/>
          <Table fullwidth hoverable striped>
            <Table.Head>
              <Table.Row>
                <Table.Heading>Data Transação</Table.Heading>
                <Table.Heading>Quantidade</Table.Heading>
                <Table.Heading>Custo Total</Table.Heading>
                <Table.Heading>Situação</Table.Heading>
                <Table.Heading></Table.Heading>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              { renderTransactionsHistory() }
            </Table.Body>
          </Table>
          <Column.Group breakpoint="mobile">
            <Column size={2} className="has-text-left">
              <Link onClick={goToMenu} className="button is-primary">Voltar</Link>
            </Column>
            <Column className="has-text-right">
              <PaginationCustom items={histories} onChangePage={onChangePage} pageSize={10}  />
            </Column>
          </Column.Group>
        </Card.Content>
      </Card>

      <Modal closeOnBlur={true} closeOnEsc={true} active={activeModal} onClose={close}>
        <Modal.Background onClick={close} />
        <Modal.Content>
          { renderModal() }
        </Modal.Content>
        <Modal.Close />
      </Modal>
    </>
  )

}

export default PdvTransactionsHistoryList;
